import { render, staticRenderFns } from "./SkuTable.vue?vue&type=template&id=124e2d40&scoped=true"
import script from "./SkuTable.vue?vue&type=script&lang=js"
export * from "./SkuTable.vue?vue&type=script&lang=js"
import style0 from "./SkuTable.vue?vue&type=style&index=0&id=124e2d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e2d40",
  null
  
)

export default component.exports